module.exports = __webpack_public_path__ + "img/quote.d1beee2c.svg";